import React from "react"
import "../../styles/components/Button.scss"

export interface IButton {
  name: string
  className?: string
  disabled?: boolean
}

const Button = ({ name, className, disabled }: IButton) => {
  return (
    <button
      className={
        className
          ? className
          : disabled
          ? "component-button__disabled"
          : "component-button"
      }
      disabled={disabled}
    >
      {name}
    </button>
  )
}

export default Button
